/**
 * UserStatusChip Component
 *
 * Displays a colored chip indicating the user's status (ACTIVE, SUSPENDED, DELETED).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { USER_STATUS, USER_STATUS_LABELS, USER_STATUS_COLORS } from '../constants';

/**
 * UserStatusChip Component
 *
 * @param {Object} props
 * @param {string} props.status - User status (ACTIVE, SUSPENDED, DELETED)
 * @param {string} [props.size="small"] - Chip size
 */
export default function UserStatusChip({ status, size = 'small' }) {
  const label = USER_STATUS_LABELS[status] || status || 'Unknown';
  const color = USER_STATUS_COLORS[status] || 'default';

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      variant="outlined"
      sx={{
        fontWeight: 600,
        textTransform: 'uppercase',
        fontSize: '0.75rem',
      }}
    />
  );
}

UserStatusChip.propTypes = {
  status: PropTypes.oneOf(Object.values(USER_STATUS)).isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
};
